@if (dataLayerTypeToDelete) {
  <p-confirmDialog
    key="dataLayerParentDeleteDialog"
    #cd
    styleClass="w-9"
    appendTo="body"
    [blockScroll]="false">
    <ng-template pTemplate="headless" let-message>
      <div class="p-card border-round pt-1 p-4">
        <app-header
          icon="fas fa-trash"
          [text]="
            dataLayerTypeToDelete.name + ' wirklich löschen?'
          "></app-header>

        @if (typeLayers && typeLayers.length) {
          <p appAlertStyle="warning" class="p-3">
            <i class="fas fa-exclamation-triangle"></i>
            Dabei werden auch alle Jahre (und die Daten dieser), die mit der
            Ebene verknüpft sind, unwiderruflich gelöscht!
          </p>
          <p-divider></p-divider>
          <app-header
            icon="fas fa-database"
            text="Enthaltene Jahre und Daten"></app-header>
          @for (layer of typeLayers; track layer._id) {
            <p-accordion class="w-full">
              <p-accordionTab>
                <ng-template pTemplate="header">
                  <span class="flex align-items-center gap-2">
                    <i class="fas fa-folder"></i> {{ layer.year }}
                  </span>
                  <p-badge
                    [value]="indicatorDataStore.countByDataLayer(layer._id)"
                    class="ml-auto mr-2" />
                </ng-template>
                <app-data-layer-data-list [dataLayer]="layer" />
              </p-accordionTab>
            </p-accordion>
          }
        } @else {
          <app-alert [canToggle]="false" styleClass="p-3">
            <i class="fas fa-circle-info"></i>
            {{
              dataLayerTypeToDelete.type === 'Point'
                ? 'Dieser Standorte'
                : 'Diesem Raum'
            }}
            sind keine Jahre oder Daten zugeordnet. Es kann sicher gelöscht
            werden.
          </app-alert>
        }

        <p-divider></p-divider>
        <div class="flex align-items-center gap-3 mt-4">
          <button
            [rounded]="true"
            [outlined]="true"
            severity="secondary"
            pButton
            icon="fas fa-times"
            label="nein, abbrechen"
            (click)="cd.reject()"></button>
          <button
            [rounded]="true"
            pButton
            [severity]="'danger'"
            icon="fas fa-check"
            label="ja, löschen"
            (click)="cd.accept()"
            class="ml-auto"></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
